import React, { useState } from "react";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import { IconButton, Menu, MenuItem } from "@mui/material";

export interface RowAction {
  key: string;
  label: string;
  onSelect: () => void;
}

const RowActionsMenu: React.FC<{ testId: string; actions: RowAction[] }> = ({
  testId,
  actions,
}) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  return (
    <>
      <IconButton
        size="small"
        aria-label="More actions"
        data-testid={testId}
        onClick={(event) => {
          event.stopPropagation();
          setAnchor(event.currentTarget);
        }}
      >
        <MoreVertOutlinedIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        onClick={(event) => {
          event.stopPropagation();
          setAnchor(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {actions.map((action) => (
          <MenuItem
            key={action.key}
            data-testid={`${testId}-${action.key}`}
            onClick={action.onSelect}
          >
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default RowActionsMenu;
